import { render, staticRenderFns } from "./AdSelect.vue?vue&type=template&id=0db2c32e&"
import script from "./AdSelect.vue?vue&type=script&lang=js&"
export * from "./AdSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0db2c32e')) {
      api.createRecord('0db2c32e', component.options)
    } else {
      api.reload('0db2c32e', component.options)
    }
    module.hot.accept("./AdSelect.vue?vue&type=template&id=0db2c32e&", function () {
      api.rerender('0db2c32e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/zch/AdSelect.vue"
export default component.exports